export default __webpack_public_path__ + "static/media/home-testimonial.0d3db806.jpg";